import React from 'react';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import {
  pageRequest,
  cancelDeleteModifier,
  deleteModifier,
  confirmApplySetItem,
  hideApplySetItemModal,
  openSetAllItemConfirmation,
  closeSetAllItemConfirmation,
} from 'actions/library/modifier';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { isDirty } from 'redux-form';
import { browserHistory } from 'react-router';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import _ from 'lodash';
import * as clevertapLibraryModifier from 'clevertap/library/modifier';
import ApplySetItemModal from './ApplySetItemModal';
import Detail from './Detail';
import List from './List';
import ActionBar from './ActionBar';
import styles from './Modifier.css';

class Modifier extends React.Component {
  constructor() {
    super();
    this.state = {
      modifierId: 0,
    };
  }

  onClickApplyAll = id => {
    const { dispatch } = this.props;

    dispatch(hideApplySetItemModal());

    this.setState({
      modifierId: id,
    });

    dispatch(openSetAllItemConfirmation());
  };

  onClickCancel = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.dispatch(closeSetAllItemConfirmation());
  };

  onClickConfirm = () => {
    const { dispatch, modifiers } = this.props;
    const { modifierId } = this.state;

    let properties = {};
    _.forEach(modifiers, modifier => {
      if (modifier.id === modifierId) {
        properties = {
          name: modifier.name,
          options: _.map(modifier.active_options, 'id'),
        };
      }
    });
    clevertapLibraryModifier.libraryModifierApplyToAllItems(properties);
    dispatch(confirmApplySetItem({ selectAllItems: true }, modifierId));
  };

  render() {
    const {
      showDeleteModifierModal,
      deletedModifier,
      openRightColumn,
      showLoadingSpinnerPage,
      modifiers,
      showSetAllItemConfirmationModal,
    } = this.props;
    const modifierName = deletedModifier ? deletedModifier.name : '';
    return (
      <PageWrapper>
        <ActionBar />
        <Modal show={showSetAllItemConfirmationModal}>
          <Modal.Header closeButton className={`${styles.danger}`}>
            <Modal.Title componentClass="div">
              Apply Modifier Set to All Items
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              Are you sure want to apply this modifier set to All Items?
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                className="btn btn-default pull-left"
                onClick={this.onClickCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.onClickConfirm}
              >
                Apply
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={modifiers.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Create Modifiers"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000454546-Cara-Membuat-Modifiers"
            />
            <List />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <Detail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ApplySetItemModal
          onSubmit={this._onSubmitApplySetItem}
          onClickApplyAll={this.onClickApplyAll}
        />
        <LibraryDeleteModal
          showDeleteModal={showDeleteModifierModal}
          onHide={this._onHideModal}
          title="Modifier"
          name={modifierName}
          onDelete={this._onDelete}
        />
        <ConfirmActionModal />
      </PageWrapper>
    );
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(pageRequest());
    browserHistory.listenBefore(location => {
      // this is still hacky, don't copy paste this
      if (this.props.isDirtyModifier && !this.props.nextAction) {
        dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  _onHideModal = () => {
    this.props.dispatch(cancelDeleteModifier());
  };

  _onDelete = () => {
    const { dispatch, deletedModifier, modifiers } = this.props;
    clevertapLibraryModifier.libraryModifierDelete({
      name: deletedModifier.name,
      options: deletedModifier.active_options,
    });
    dispatch(deleteModifier(deletedModifier.id, modifiers));
  };

  _onSubmitApplySetItem = values => {
    const { dispatch, modifiers } = this.props;
    let properties = {};
    _.forEach(modifiers, modifier => {
      if (modifier.id === values.id) {
        properties = {
          name: modifier.name,
          options: _.map(modifier.active_options, 'name'),
          itemNames: values.itemIds,
        };
      }
    });
    clevertapLibraryModifier.libraryModifierApplyToItems(properties);
    dispatch(confirmApplySetItem({ item_ids: values.itemIds }, values.id));
  };
}

function mapStateToProps(state) {
  const {
    showDeleteModifierModal,
    modifiers,
    deletedModifier,
    openRightColumn,
    showSetAllItemConfirmationModal,
  } = state.library.modifier;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    isDirtyModifier: isDirty('modifier')(state),
    nextAction: state.confirmAction.nextAction,
    showDeleteModifierModal,
    modifiers,
    deletedModifier,
    openRightColumn,
    showLoadingSpinnerPage,
    showSetAllItemConfirmationModal,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modifier);
